import React from "react";
import Hero from "./Hero";
import Footer from "../../components/Hero/Footer";
import ContactInfo from "./ContactInfo";
import ContactForm from "./ContactForm";
import ContactMap from "./ContactMap";
import Navbar from "../../components/Hero/Navbar";

export default function Contact() {
  return (
    <div className="bg-[#f6fcff]">
      <Navbar />
      <Hero />
      <ContactInfo />
      <ContactForm />
      <ContactMap />
      <Footer />
    </div>
  );
}
